import { Canvas } from '@react-three/fiber';
import { Leva } from 'leva';
import Import from './Import';
import React, { useContext, useRef } from 'react';
import * as THREE from 'three';
import { ThreeContext } from './Context';
import { Perf } from 'r3f-perf';
import { OrbitControls} from '@react-three/drei';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1,//5*(60*1000), // 5 mins
        cacheTime: 1,//10*(60*1000), // 10 mins
      },
    },
  });

export default function App(){

    // Run When Canvas is Executed 
    const Created = ({gl, scene}) => {
        const Color = "#ff0000";
        scene.fog = new THREE.Fog(Color, 0, 100000);
    }
    
    const { debug, perf } = useContext(ThreeContext);
    const orbitRef = useRef();

    return(
        <QueryClientProvider client={queryClient}>
             {/* hidden={!debug} */}
            <Leva className="test" />
           
            <Canvas
                flat
                shadows
                dpr={[1,2]}
                camera={ { zoom : 1, fov: 45, near: 0.1, far: 5000, position: [ 0, 15.5, 35] } }
                gl={{antialias : true}}
                onCreated={Created}
                performance={{ min: 0.5 }}
                className={`Debug-${debug}`}
            >   

             <OrbitControls makeDefault  
                ref={orbitRef}   
                maxDistance={80} 
                minDistance={4}       
            />

                {(debug || perf) && <Perf position="top-left" minimal={false}/>}
              
                <Import render={1} />
            </Canvas>
        </QueryClientProvider>
    )
}